import { useEffect, useState } from "react";
import InputFactory from "../../../../../components/InputFactory";
import FormField from "./FormField";
import { formatTinNo } from "./utils";
import RadioGroup from "../../../../../components/RadioGroup";
import FormFactory from "../../../../../components/FormFactory";
import { filterFieldsByKeys } from "../../../../../filterFieldsByKeys";

function BasicInfoFields({ formData, onChange, schema, schemas }) {
  const [formDatas, setFormDatas] = useState({
    name: formData?.name || "",
    isVatable: formData?.isVatable || false,
    tinNo: formatTinNo(formData?.tinNo) || "",
  });

  const [hasTinNo, setHasTin] = useState(Boolean(formData?.tinNo));

  useEffect(() => {
    setHasTin(Boolean(formData?.tinNo));
  }, [formData?.tinNo]);

  useEffect(() => {
    setFormDatas({
      name: formData?.name || "",
      isVatable: formData?.isVatable || false,
      tinNo: formatTinNo(formData?.tinNo) || "",
    });
  }, [formData]);

  const _onChange = (value, field) => {
    if (field === "tinNo") {
      value = formatTinNo(value);
    }
    if (field === "hasTin") {
      setHasTin(value);
      if (!value) {
        setFormDatas((prev) => ({
          ...prev,
          tinNo: "",
          isVatable: false,
        }));
        onChange("", "tinNo");
        onChange(false, "isVatable");
      }
      return;
    }

    setFormDatas((prev) => ({ ...prev, [field]: value }));
    onChange(value, field);
  };

  return (
    <div className="d-flex flex-column gap-3 justify-content-between">
      <FormFactory
        object={formData}
        schema={filterFieldsByKeys(schema, [
          "name",
          "firstName",
          "middleName",
          "lastName",
        ])}
        onChange={_onChange}
      />

      <InputFactory
        type="Boolean"
        label="Has TIN No.?"
        field="hasTin"
        className="cursor-pointer"
        value={hasTinNo}
        defaultValue={hasTinNo}
        onChange={(value) => _onChange(value, "hasTin")}
      />

      {hasTinNo && (
        <div className="border p-4 rounded-3 d-flex flex-column gap-2 bg-light-subtle">
          <FormField label="Tax Identification Number" required>
            <InputFactory
              type="String"
              field="tinNo"
              required
              placeholder="e.g. 123-456-789-00000"
              maxLength={17}
              minLength={11}
              value={formDatas.tinNo}
              className="border border-1 border-dark-subtle bg-white"
              onChange={_onChange}
            />
          </FormField>

          <RadioGroup
            label=""
            name="example"
            field="isVatable"
            options={[
              { label: "Vatable", value: true },
              { label: "Non Vatable", value: false },
            ]}
            value={formDatas.isVatable}
            onChange={_onChange}
            className="p-1"
            required
          />
        </div>
      )}
    </div>
  );
}

export default BasicInfoFields;
